module.exports = __webpack_public_path__ + "static/media/play-black-icon.5a627cb4.svg";